<template>
	<div class='agent'>
		<div class='user'>
			<a class='image' :href='`/profile/${user.id}/`'>
				<img :src='user.photo_small' >
				<div class='agent-icon agent-icon-md'>
					<icon icon-name='agent'/>
				</div>
			</a>
			<div class='data'>
				<a class='name' v-if='user.name' :href='`/profile/${user.id}/`' >{{user.name}}</a>
				<!-- <div class='name' v-else>{{user.name}}</div> -->
				<div class='major-market' v-if='user.major_market'>
					<span class='label'>Major Market: </span>
					<a class='value' :href='`/markets/${user.major_market.id}/`'>{{user.major_market.name}}, {{user.major_market.region.name}}</a>
				</div>
				<div class='sub-market' v-if='user.sub_market'>
					<span class='label'>Sub Market: </span>
					<a class='value' :href='`/markets/${user.sub_market.id}/`'>{{user.sub_market.name}}, {{user.sub_market.region.name}}</a>
				</div>
				<div class='sub-market' v-if='user.phone'>
					<span class='label'>Phone: </span>
					<a class='value' :href='`tel:${user.phone}`'>{{user.phone}}</a>
				</div>
				<div class='sub-market' v-if='user.email'>
					<span class='label'>Email: </span>
					<a class='value' :href='`tel:${user.email}`'>{{user.email}}</a>
				</div>
			</div>
		</div>
		<div class='actions'>
			<a @click='approveHandle' class='button' v-if='requests'>
				<svg class='icon'>
					<use xlink:href='#icon-approve'/>
				</svg>
				<span class='approve-btn'>Approve</span>
			</a>
			<a @click='rejectHandle' class='button'  v-if='requests'>
				<svg class='icon'>
					<use xlink:href='#icon-reject'/>
				</svg>
				<span class='reject-btn'>Reject</span>
			</a>
			<a @click='revokeHandle' class='button'  v-if='!requests'>
				<svg class='icon'>
					<use xlink:href='#icon-reject'/>
				</svg>
				<span class='reject-btn'>Revoke agent</span>
			</a>
		</div>
	</div>
</template>

<script>
import api from '__jsVueApi';
import EventBus from '__jsEbentBus';
import icon from '__jsVueUI/icon.vue';
export default {
	name:  'Agent',
	props: {
		user: {
			type: Object
		},
		requests: {
			type:    Boolean,
			default: false
		},
	},
	components: {
		icon
	},
	methods: {
		async approveHandle() {
			await axios.post(api.admin.agents.requests.accept(this.user.id)).then((response) => {
				this.$toastr.i('<div class="toastr"><div class="toastr__check"></div><p class="toastr__text">User has been approved</p></div>');
				this.$emit('update');
			});
		},
		async rejectHandle() {
			EventBus.$emit('confirm', {
				onOk: async() => {
					await axios.post(api.admin.agents.requests.reject(this.user.id)).then((response) => {
						this.$toastr.i('<div class="toastr"><div class="toastr__check"></div><p class="toastr__text">User has been rejected</p></div>');
						this.$emit('update');
					});
				},
				message: `Are you sure you want to reject agent for ${this.user.name}?`
			});
		},
		async revokeHandle() {
			EventBus.$emit('confirm', {
				onOk: async() => {
					await axios.patch(api.admin.agents.certified.revoke(this.user.id), {
						type: 'investor'
					}).then((response) => {
						this.$toastr.i('<div class="toastr"><div class="toastr__check"></div><p class="toastr__text">User has been revoked</p></div>');
						this.$emit('update');
					});
				},
				message: `Are you sure you want to revoke agent for ${(this.user.name) ? (this.user.name) : (this.user.name)}?`
			});
		},
	}
};
</script>
